import { render } from "./PurchaseCreateAndEditComponent.vue?vue&type=template&id=644d056c"
import script from "./PurchaseCreateAndEditComponent.vue?vue&type=script&lang=js"
export * from "./PurchaseCreateAndEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/purchase/PurchaseCreateAndEditComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "644d056c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('644d056c', __exports__)) {
    api.reload('644d056c', __exports__)
  }
  
  module.hot.accept("./PurchaseCreateAndEditComponent.vue?vue&type=template&id=644d056c", () => {
    api.rerender('644d056c', render)
  })

}


export default __exports__